import type { ChatType } from '@form-factory/schema';
import { useLingui } from '@lingui/react/macro';
import { Button, Input, Label } from '@utima/ui';
import { useFormContext } from '@utima/ui-informed';
import { Copy } from 'lucide-react';
import { useCallback } from 'react';

import { Card } from '@/components/card/Card';
import { SchemaFields } from '@/components/form/SchemaFields';
import { useFieldsSchema } from '@/components/form/useFieldsSchema';
import { AppSettings } from '@/constants/AppSettings';
import { useAccess } from '@/hooks/useAccess';

// TODO: DO NOT use this until we have a new omnichannel solution
export function OmnichannelConfigFields() {
  const { hasAccess } = useAccess();

  const { t } = useLingui();

  const { initialValues } = useFormContext<ChatType>();

  const webhookUrl = `${AppSettings.coreAiUrl}/omnichannel/${initialValues?.id}/inbound`;

  const { schema: detailsSchema } = useFieldsSchema(
    [
      {
        name: 'omnichannelConfig.accessKey',
        label: t`Bird.com Access key`,
      },
      {
        name: 'omnichannelConfig.workspaceId',
        label: t`Workspace ID`,
      },
    ],
    [t, hasAccess],
  );

  const copyWebhookUrl = useCallback(
    () => navigator.clipboard.writeText(webhookUrl),
    [webhookUrl],
  );

  return (
    <Card title={t`Omnichannel settings`}>
      <SchemaFields schema={detailsSchema} />
      {initialValues?.id && (
        <div className='flex w-full flex-col gap-2'>
          <Label htmlFor='webhook-url'>{t`Webhook URL`}</Label>
          <Input
            id='webhook-url'
            value={webhookUrl}
            readOnly
            addonAfter={
              <Button
                data-cta='admin-omnichannel-config-copy-button'
                className='p-0'
                variant={null}
                size='xs'
                onClick={copyWebhookUrl}
              >
                <Copy className='size-4' />
              </Button>
            }
          />
        </div>
      )}
    </Card>
  );
}
